export var isRefreshDisabled = function (conditions) {
    var isRefreshInProgress = conditions.isRefreshInProgress, isListInactive = conditions.isListInactive, isListInDraft = conditions.isListInDraft, isExportInProgress = conditions.isExportInProgress;
    return [isRefreshInProgress,
        isListInactive,
        isListInDraft,
        isExportInProgress].some(function (value) { return value; });
};
export var isCancelRefreshDisabled = function (conditions) {
    var isCancelRefreshInProgress = conditions.isCancelRefreshInProgress;
    return Boolean(isCancelRefreshInProgress);
};
export var isEditDisabled = function (conditions) {
    var isRefreshInProgress = conditions.isRefreshInProgress, isListCanned = conditions.isListCanned, isExportInProgress = conditions.isExportInProgress;
    return [isRefreshInProgress,
        isListCanned,
        isExportInProgress].some(function (value) { return value; });
};
export var isDeleteDisabled = function (conditions) {
    var isDeleteInProgress = conditions.isDeleteInProgress, isRefreshInProgress = conditions.isRefreshInProgress, isListCanned = conditions.isListCanned, isExportInProgress = conditions.isExportInProgress;
    return [isDeleteInProgress,
        isRefreshInProgress,
        isListCanned,
        isExportInProgress].some(function (value) { return value; });
};
export var isExportDisabled = function (conditions) {
    var isRefreshInProgress = conditions.isRefreshInProgress, isDeleteInProgress = conditions.isDeleteInProgress, isExportInProgress = conditions.isExportInProgress, isListInDraft = conditions.isListInDraft, isListInactive = conditions.isListInactive, isListEmpty = conditions.isListEmpty;
    return [isRefreshInProgress,
        isDeleteInProgress,
        isExportInProgress,
        isListInDraft,
        isListEmpty,
        isListInactive].some(function (value) { return value; });
};
export var isCancelExportDisabled = function (conditions) {
    var isCancelExportInProgress = conditions.isCancelExportInProgress;
    return Boolean(isCancelExportInProgress);
};
